/**
 * @generated SignedSource<<444071c619041b3d6a89f4a396acaa25>>
 * @relayHash 0b6eb0c8d9d0e7bfb63f1062d281d3f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57f97595099b71ac1a1c7e242a7bb13434487e7d2465c74fd6a2f9cfff0258db

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookDetailQuery } from './PlaybookDetailQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookDetailQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "57f97595099b71ac1a1c7e242a7bb13434487e7d2465c74fd6a2f9cfff0258db",
    "metadata": {},
    "name": "PlaybookDetailQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
